/*
 * @Author: 刘小博
 * @Date: 2023-02-03 14:58:56
 * @LastEditTime: 2024-05-21 17:36:22
 * @LastEditors: 肖玲
 * @Description:
 * 批量操作
 */
import { getDetail as getFieldDetail } from '@/api/field'
import store from '@/store'
import { getAuthClientList } from '@/api/common'

const batchOperationRouter = [
  // 档案导入列表
  {
    path: '/masterDataSystem/client-import-list',
    name: 'clientImportList',
    component: () =>
      import(
        /*webpackChunkName:"clientImport" */
        // '@/views/masterDataSystem/ClientImportList.vue'
        '@/views/master-data/file-operation-manage/batch-operation/file-operation/Page.vue'
      ),
    meta: {
      SecondaryMenu: '批量操作', //二级菜单
      title: '档案操作'
    }
  },

  // 档案导入列表
  {
    path: '/masterDataSystem/doc-level/upload',
    name: 'docLevelUpload',
    component: () =>
      import(
        /*webpackChunkName:"docLevelUpload" */
        '@/views/master-data/file-operation-manage/batch-operation/file-operation/update-level/Upload.vue'
      ),
    meta: {
      SecondaryMenu: '批量操作', //二级菜单
      title: '更新定级问卷',
      breadcrumb: [
        {
          title: '档案操作',
          name: 'clientImportList'
        }
      ]
    }
  },

  // 档案导入
  {
    path: '/masterDataSystem/client-import/:cls',
    name: 'clientImport',
    component: () =>
      import(
        /*webpackChunkName:"clientOperation" */
        // '@/views/masterDataSystem/ClientImport.vue'
        '@/views/master-data/file-operation-manage/batch-operation/file-operation/Import.vue'
      ),
    meta: {
      SecondaryMenu: '批量操作', //二级菜单
      title: '导入终端',
      breadcrumb: [
        {
          title: '档案操作',
          name: 'clientImportList'
        }
      ]
    }
  },
  // 档案导入 全部
  {
    path: '/masterDataSystem/bulk-import',
    name: 'masterDataSystemBulkImport',
    component: () =>
      import(
        /*webpackChunkName:"masterDataSystemBulkImport" */
        // '@/views/masterDataSystem/file-batch-import/BulkImport.vue'
        '@/views/master-data/file-operation-manage/batch-operation/file-operation/bulk-import/Page.vue'
      ),
    meta: {
      SecondaryMenu: '批量操作', //二级菜单
      title: '档案批量导入',
      breadcrumb: [
        {
          title: '档案操作',
          name: 'clientImportList'
        }
      ]
    }
  },
  // 导入全部档案模板配置
  {
    path: '/masterDataSystem/file-batch-import',
    name: 'masterDataSystemFileBatchImport',
    component: () =>
      import(
        /*webpackChunkName:"masterDataSystemAddMaterials" */
        // '@/views/masterDataSystem/file-batch-import/FileBatchImport.vue'
        '@/views/master-data/file-operation-manage/batch-operation/file-operation/bulk-import/TemplateConfig.vue'
      ),
    meta: {
      SecondaryMenu: '系统设置', //二级菜单
      title: '导入全部档案模板',
      breadcrumb: [
        {
          title: '系统配置',
          name: 'masterDataSettingManage'
        }
      ]
    }
  },
  // 更新基础信息
  {
    path: '/masterDataSystem/client-update/:cls',
    name: 'clientInfoUpdate',
    component: () =>
      import(
        /*webpackChunkName:"clientOperation" */
        // '@/views/masterDataSystem/ClientInfoUpdate.vue'
        '@/views/master-data/file-operation-manage/batch-operation/file-operation/Update.vue'
      ),
    meta: {
      SecondaryMenu: '批量操作', //二级菜单
      title: '更新终端信息',
      breadcrumb: [
        {
          title: '档案操作',
          name: 'clientImportList'
        }
      ]
    }
  },

  // 删除档案
  {
    path: '/masterDataSystem/client-delete-batch/:cls',
    name: 'clientDeleteBatch',
    component: () =>
      import(
        /*webpackChunkName:"clientOperation" */
        // '@/views/masterDataSystem/ClientDeleteBatch.vue'
        '@/views/master-data/file-operation-manage/batch-operation/file-operation/delete/Page.vue'
      ),
    meta: {
      SecondaryMenu: '批量操作', //二级菜单
      title: '删除档案',
      breadcrumb: [
        {
          title: '档案操作',
          name: 'clientImportList'
        }
      ]
    }
  },
  // 批量删除档案
  {
    path: '/masterDataSystem/client-delete/:cls',
    name: 'clientDelete',
    component: () =>
      import(
        /*webpackChunkName:"clientOperation" */
        // '@/views/masterDataSystem/ClientDelete.vue'
        '@/views/master-data/file-operation-manage/batch-operation/file-operation/delete/AllDelete.vue'
      ),
    meta: {
      SecondaryMenu: '批量操作', //二级菜单
      title: '删除档案',
      breadcrumb: [
        {
          title: '档案操作',
          name: 'clientImportList'
        }
      ]
    }
  },

  // 档案操作 关联档案
  {
    path: '/masterDataSystem/relevancy-record/:cls/:arr_id/:client_custom_id/:relation_cls',
    name: 'bonusReturnSystemRelevancyRecord',
    component: () =>
      import(
        /*webpackChunkName:"bonusReturnSystemRelevancyRecord" */
        // '@/views/masterDataSystem/RelevancyRecord.vue'
        '@/views/master-data/file-operation-manage/batch-operation/file-operation/Relevance.vue'
      ),
    meta: {
      SecondaryMenu: '批量操作', //二级菜单
      title: '关联档案',
      breadcrumb: [
        {
          title: '档案操作',
          name: 'clientImportList'
        }
      ]
    }
  },

  // 修改档案类型
  {
    path: '/masterDataSystem/change-client-type',
    name: 'changeClientType',
    component: () =>
      import(
        /*webpackChunkName:"clientOperation" */
        // '@/views/masterDataSystem/ChangeClientType.vue'
        '@/views/master-data/file-operation-manage/batch-operation/file-operation/update-type/Page.vue'
      ),
    meta: {
      SecondaryMenu: '批量操作', //二级菜单
      title: '修改档案类型',
      breadcrumb: [
        {
          title: '档案操作',
          name: 'clientImportList'
        }
      ]
    }
  },

  // 修改档案类型 批量修改
  {
    path: '/masterDataSystem/batch-change-client-type',
    name: 'BatchchangeClientType',
    component: () =>
      import(
        /*webpackChunkName:"clientOperation" */
        // '@/views/masterDataSystem/BatchChangeClientType.vue'
        '@/views/master-data/file-operation-manage/batch-operation/file-operation/update-type/AllUpdate.vue'
      ),
    meta: {
      SecondaryMenu: '批量操作', //二级菜单
      isMoreMeta: true,
      breadcrumb: [
        {
          title: '档案操作',
          name: 'clientImportList'
        },
        {
          title: '修改档案类型',
          name: 'changeClientType'
        }
      ]
    }
  },

  // 修改档案类型 批量修改 批量修改档案
  {
    path: '/masterDataSystem/batch-change-client-type-edit',
    name: 'BatchchangeClientTypeEdit',
    component: () =>
      import(
        /*webpackChunkName:"clientOperation" */
        // '@/views/masterDataSystem/BatchChangeClientType.vue'
        '@/views/master-data/file-operation-manage/batch-operation/file-operation/update-type/BatchUpdate.vue'
      ),
    meta: {
      SecondaryMenu: '批量操作', //二级菜单
      isMoreMeta: true,
      title: '批量修改',
      breadcrumb: [
        {
          title: '档案操作',
          name: 'clientImportList'
        },
        {
          title: '修改档案类型',
          name: 'changeClientType'
        }
      ]
    }
  },

  // 岗位/产品/终端关联-维护备案
  {
    path: '/jurisdictionSystem/jurisdiction-import/:meta_type/:batch_id',
    name: 'jurisdictionImport',
    component: () =>
      import(
        /*webpackChunkName:"jurisdiction" */
        // '@/views/jurisdictionSystem/manage/ClientImport.vue'
        '@/views/master-data/file-operation-manage/batch-operation/file-operation/Maintain.vue'
      ),
    meta: {
      SecondaryMenu: '辖区关系', //二级菜单
      isMoreMeta: true,
      1: {
        title: '批量产品分线',
        breadcrumb: [
          {
            title: '岗位/产品/终端关联',
            name: 'jurisdictionManage'
          }
        ]
      },
      2: {
        title: '批量分配辖区',
        breadcrumb: [
          {
            title: '岗位/产品/终端关联',
            name: 'jurisdictionManage'
          }
        ]
      },
      3: {
        title: '批量设置共岗',
        breadcrumb: [
          {
            title: '岗位/产品/终端关联',
            name: 'jurisdictionManage'
          }
        ]
      },
      4: {
        title: '导入共岗比例',
        breadcrumb: [
          {
            title: '岗位/产品/终端关联',
            name: 'jurisdictionManage'
          }
        ]
      }
    }
  },

  // 综合产品分线
  {
    path: '/jurisdictionSystem/jurisdiction-manage/product-line-import',
    name: 'comperProductLine',
    component: () =>
      import(
        /*webpackChunkName:"masterDataSystemMerge" */
        // '@/views/masterDataSystem/ClientMerge.vue'
        '@/views/jurisdiction-manage/dept-juris-manage/juris-relation/jurisdiction-manage/ComperProductLine.vue'
      ),
    meta: {
      SecondaryMenu: '批量操作', //二级菜单
      title: '综合产品分线',
      breadcrumb: [
        {
          title: '岗位/产品/终端关联',
          name: 'jurisdictionManage'
        }
      ]
    }
  },

  // 窗口期更新数据查询
  {
    path: '/jurisdictionSystem/jurisdiction-manage/import',
    name: 'jurisdictionManageImport',
    component: () =>
      import(
        '@/views/jurisdiction-manage/dept-juris-manage/juris-relation/jurisdiction-manage/Import.vue'
      ),
    meta: {
      SecondaryMenu: '辖区关系', //二级菜单
      isMoreMeta: true,
      title: '窗口期更新数据查询',
      breadcrumb: [
        {
          title: '岗位/产品/终端关联',
          name: 'jurisdictionManage'
        }
      ]
    }
  },

  // 档案合并
  {
    path: '/masterDataSystem/client-merge',
    name: 'masterDataSystemClientMerge',
    component: () =>
      import(
        /*webpackChunkName:"masterDataSystemMerge" */
        // '@/views/masterDataSystem/ClientMerge.vue'
        '@/views/master-data/file-operation-manage/batch-operation/file-operation/merge/Page.vue'
      ),
    meta: {
      SecondaryMenu: '批量操作', //二级菜单
      title: '档案合并',
      breadcrumb: [
        {
          title: '档案操作',
          name: 'clientImportList'
        }
      ]
    }
  },
  // 档案批量合并
  {
    path: '/masterDataSystem/client-merge-upload',
    name: 'masterDataSystemClientMergeUpload',
    component: () =>
      import(
        /*webpackChunkName:"masterDataSystemMerge" */
        // '@/views/masterDataSystem/ClientMergeUpload.vue'
        '@/views/master-data/file-operation-manage/batch-operation/file-operation/merge/AllMerge.vue'
      ),
    meta: {
      SecondaryMenu: '批量操作', //二级菜单
      title: '档案批量合并'
    }
  },
  // 档案合并记录
  {
    path: '/masterDataSystem/client-merge-reccord',
    name: 'masterDataSystemClientMergeRecord',
    component: () =>
      import(
        /*webpackChunkName:"masterDataSystemMerge" */
        // '@/views/masterDataSystem/ClientMergeRecord'
        '@/views/master-data/file-operation-manage/batch-operation/file-operation/merge/Record.vue'
      ),
    meta: {
      SecondaryMenu: '批量操作', //二级菜单
      title: '档案合并记录',
      breadcrumb: [
        {
          title: '档案操作',
          name: 'clientImportList'
        },
        {
          title: '档案合并',
          name: 'masterDataSystemClientMerge'
        }
      ]
    }
  },
  // 停用档案
  {
    path: '/masterDataSystem/disable-files',
    name: 'disableFiles',
    component: () =>
      import(
        /*webpackChunkName:"clientOperation" */
        // '@/views/masterDataSystem/disableFiles/index.vue'
        '@/views/master-data/file-operation-manage/batch-operation/file-operation/block-up/Page.vue'
      ),

    beforeEnter(to, from, next) {
      getAuthClientList([1, 2, 3, 4, 5, 7, 9]).then((res) => {
        if (0 === res.status) {
          let classList = res.data.classList
          store.commit('setClientClassList', classList)
        }
        next()
      })
    },
    meta: {
      SecondaryMenu: '批量操作', //二级菜单
      title: '停用档案',
      breadcrumb: [
        {
          title: '档案操作',
          name: 'clientImportList'
        }
      ]
    }
  },
  // 停用档案 批量操作
  {
    path: '/masterDataSystem/disable-files/batch-operation',
    name: 'disableFilesBatchOperation',
    component: () =>
      import(
        /*webpackChunkName:"clientOperation" */
        // '@/views/masterDataSystem/disableFiles/batchOperation.vue'
        '@/views/master-data/file-operation-manage/batch-operation/file-operation/block-up/AllBlockUp.vue'
      ),

    beforeEnter(to, from, next) {
      getAuthClientList([1, 2, 3, 4, 5, 7, 9]).then((res) => {
        if (0 === res.status) {
          let classList = res.data.classList
          store.commit('setClientClassList', classList)
        }
        next()
      })
    },
    meta: {
      SecondaryMenu: '批量操作', //二级菜单
      title: '批量操作',
      breadcrumb: [
        {
          title: '档案操作',
          name: 'clientImportList'
        },
        {
          title: '停用档案',
          name: 'disableFiles'
        }
      ]
    }
  },

  // 档案曾用名维护
  {
    path: '/masterDataSystem/former-name',
    name: 'formerName',
    component: () =>
      import(
        /*webpackChunkName:"clientOperation" */
        // '@/views/masterDataSystem/formerName/index.vue'
        '@/views/master-data/file-operation-manage/batch-operation/file-operation/FormerName.vue'
      ),
    meta: {
      SecondaryMenu: '批量操作', //二级菜单
      title: '档案曾用名维护',
      breadcrumb: [
        {
          title: '档案操作',
          name: 'clientImportList'
        }
      ]
    }
  },

  // 档案匹配
  {
    path: '/masterDataSystem/client-matching',
    name: 'clientMatching',
    component: () =>
      import(
        /*webpackChunkName:"clientImport" */
        // '@/views/masterDataSystem/ClientMatching.vue'
        '@/views/master-data/file-operation-manage/batch-operation/file-matching/Page.vue'
      ),
    meta: {
      SecondaryMenu: '批量操作', //二级菜单
      title: '档案匹配'
    }
  },

  // 档案匹配导入
  {
    path: '/masterDataSystem/client-matching-import',
    name: 'masterDataSystemClientMatchingImport',
    component: () =>
      import(
        /*webpackChunkName:"recordClient" */
        // '@/views/masterDataSystem/ClientMatchingImport.vue'
        '@/views/master-data/file-operation-manage/batch-operation/file-matching/Import.vue'
      ),
    meta: {
      SecondaryMenu: '批量操作', //二级菜单
      title: '批量匹配',
      breadcrumb: [
        {
          title: '档案匹配',
          name: 'clientMatching'
        }
      ]
    }
  },
  // 档案字段管理
  {
    path: '/masterDataSystem/field-manage',
    name: 'fieldManage',
    component: () =>
      import(
        /*webpackChunkName:"field" */
        // '@/views/masterDataSystem/field/Manage.vue'
        '@/views/master-data/file-operation-manage/batch-operation/file-field-manage/Page.vue'
      ),
    meta: {
      SecondaryMenu: '批量操作', //二级菜单
      title: '档案字段管理'
    }
  },
  // 档案字段翻页列表
  {
    path: '/masterDataSystem/field-page/:cls',
    name: 'fieldPage',
    component: () =>
      import(
        /*webpackChunkName:"field" */
        // '@/views/masterDataSystem/field/Page.vue'
        '@/views/master-data/file-operation-manage/batch-operation/file-field-manage/edit/Page.vue'
      ),
    meta: {
      SecondaryMenu: '批量操作', //二级菜单
      title: '档案字段列表',
      breadcrumb: [
        {
          title: '档案字段管理',
          name: 'fieldManage'
        }
      ]
    }
  },
  // 档案字段添加
  {
    path: '/masterDataSystem/field-add/:cls',
    name: 'fieldAdd',
    component: () =>
      import(
        /*webpackChunkName:"field" */
        // '@/views/masterDataSystem/field/Edit.vue'
        '@/views/master-data/file-operation-manage/batch-operation/file-field-manage/edit/Add.vue'
      ),
    meta: {
      SecondaryMenu: '批量操作', //二级菜单
      title: '添加字段',
      breadcrumb: [
        {
          title: '档案字段管理',
          name: 'fieldManage'
        },
        {
          title: '档案字段列表',
          name: 'fieldPage'
        }
      ]
    }
  },
  // 档案字段编辑
  {
    path: '/masterDataSystem/field-edit/:id/:type/:is_admin/:is_modify/:item/:is_system',
    name: 'fieldEdit',
    component: () =>
      import(
        /*webpackChunkName:"field" */
        // '@/views/masterDataSystem/field/Edit.vue'
        '@/views/master-data/file-operation-manage/batch-operation/file-field-manage/edit/Edit.vue'
      ),
    beforeEnter(to, from, next) {
      const { id } = to.params
      getFieldDetail(id).then((res) => {
        if (0 === res.status) {
          const data = res.data
          store.commit('setFieldDetail', data)
          next()
        } else {
          store.commit('setFieldDetail', {})
        }
      })
    },
    meta: {
      SecondaryMenu: '批量操作', //二级菜单
      title: '编辑字段',
      breadcrumb: [
        {
          title: '档案字段管理',
          name: 'fieldManage'
        },
        {
          title: '档案字段列表',
          name: 'fieldPage'
        }
      ]
    }
  },
  // 档案字段排序
  {
    path: '/masterDataSystem/field/sort/:cls',
    name: 'fieldSort',
    component: () =>
      import(
        /*webpackChunkName:"field" */
        // '@/views/masterDataSystem/field/Sort.vue'
        '@/views/master-data/file-operation-manage/batch-operation/file-field-manage/edit/Sort.vue'
      ),
    meta: {
      SecondaryMenu: '批量操作', //二级菜单
      title: '字段排序',
      breadcrumb: [
        {
          title: '档案字段管理',
          name: 'fieldManage'
        },
        {
          title: '档案字段列表',
          name: 'fieldPage'
        }
      ]
    }
  }
]

export default batchOperationRouter
